// extracted by mini-css-extract-plugin
export default {"wrapper":"MainContent_wrapper__fSjVa"};